import { Card, ConfigProvider, Descriptions, Flex } from 'antd';
import invariant from 'tiny-invariant';
import { useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';
import {
  isModuleEnabled,
  usePermissions,
} from 'business/contextProviders/usePermissions';
import { Module_Enum } from 'generated/graphql';

export const DetailsHeader = ({
  ringNumber,
  ringKey,
  segmentType,
  serialNumber,
}: {
  ringNumber: number;
  ringKey: number;
  segmentType: string | null;
  serialNumber: string | null;
}) => {
  const { currentConstructionSite } = useAppContext();
  invariant(currentConstructionSite, 'No construction site id');

  const { isDataManager } = usePermissions();

  const { t } = useTranslation();

  const items = [
    {
      key: 'ringNumber',
      label: t('qualityControl.defectReportHistory.ring'),
      children: ringNumber,
    },
    {
      key: 'ringPosition',
      label: t('qualityControl.defectReportHistory.ringKey'),
      children: `P${ringKey}`,
    },
    {
      key: 'segmentType',
      label: t('qualityControl.defectReportHistory.segmentType'),
      children: segmentType ?? '-',
    },
  ];

  const qualityScanModuleIsEnabled = isModuleEnabled(
    isDataManager,
    currentConstructionSite,
    Module_Enum.QualityScan,
  );
  if (qualityScanModuleIsEnabled) {
    items.push({
      key: 'serialNumber',
      label: t('qualityControl.defectReportHistory.serialNumber'),
      children: serialNumber ?? '-',
    });
  }

  return (
    <Flex gap={4} align="center">
      <Card className="flex-15">
        <ConfigProvider
          theme={{
            components: {
              Descriptions: {
                itemPaddingBottom: 4,
                labelColor: '#595959',
              },
            },
          }}
        >
          <Descriptions
            items={items}
            colon={false}
            layout="vertical"
            column={qualityScanModuleIsEnabled ? 4 : 3}
          />
        </ConfigProvider>
      </Card>
    </Flex>
  );
};
